import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { SliderModule } from 'primeng/slider';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TreeTableModule } from 'primeng/treetable';
import { OsModule } from '../../rmpv/rmpv-detalhado-os/os.module';
import { ComumModule } from '../../../shared/comum.module';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { ConsultaEstoqueFiltroComponent } from './veiculo-estoque-filtro/veiculo-estoque-filtro.component';
import { ConsultaEstoqueFiltroService } from './veiculo-estoque-filtro/veiculo-estoque-filtro.service';
import { ConsultaEstoqueListaComponent } from './veiculo-estoque-lista/veiculo-estoque-lista.component';
import { ConsultaEstoqueService } from './veiculo-estoque-service/veiculo-estoque.service';
import { ConsultaEstoqueComponent } from './veiculo-estoque.component';
import { CheckboxModule } from 'primeng/checkbox';



@NgModule({
  imports: [
    HttpClientModule,
    BrowserAnimationsModule,
    TreeTableModule,
    TableModule,
    ButtonModule,
    ToastModule,
    CalendarModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    ProgressBarModule,
    InputTextModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    ChartsModule,
    OsModule,
    CheckboxModule,
    NgbModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    ConsultaEstoqueComponent
  ],
  declarations: [
    ConsultaEstoqueComponent,
    ConsultaEstoqueFiltroComponent,
    ConsultaEstoqueListaComponent
  ],
  providers: [
    ConsultaEstoqueService,
    ConsultaEstoqueFiltroService
  ]
})
export class ConsultaEstoqueModule { }
